<template>
  <v-treeview
    v-model="tree"
    ref="TreeList"
    activatable
    item-key="id"
    :items="items"
    :active.sync="active"
  ></v-treeview>
</template>

<script>
export default {
  props: {
    listItems: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      lista: this.listItems,
      active: null,
      tree: [],
    };
  },
  watch: {
    active: {
      handler(selecionado) {
        if (selecionado.length > 0) {
          this.$emit('addTextModal', this.listItems.find(item => item.id === selecionado[0]));
          this.active = [];
        }
      },
    },
  },
  computed: {
    items() {
      if (this.listItems) {
        const pais = this.listItems.filter(
          (item) => item.parent_id == 0,
        );
        if (pais) {
          const pais2 = pais.map((item) => this.lista_recursiva(item));
          return pais2;
        }
      }
      return [];
    },
  },
  methods: {
    lista_recursiva(pai) {
      const lista = this.listItems.filter(
        (item) => item.parent_id == pai.id,
      );
      if (lista) {
        lista.map((item) => ({
          ...item,
          children: this.lista_recursiva(item),
        }));
        pai.children = lista;
        return pai;
      }
      return [];
    },
  },
};
</script>
